import { render, staticRenderFns } from "./PaymentDisabledPage.vue?vue&type=template&id=06659f92&"
import script from "./PaymentDisabledPage.vue?vue&type=script&lang=js&"
export * from "./PaymentDisabledPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports